// module imports
import { eventDispatch } from 'modules/GlobalEvents/Events'
import summaryList from 'modules/SessionSummary/SummaryList'
// constant imports
import { DISPATCH_EVENTS } from 'constants/GlobalEvents'
import * as C from 'redux/Sessions/constants'

const actions = [
  C.ACCEPTED,
  C.HOLD_TOGGLE,
  C.HOLD_ACTIVE,
  C.UNHOLD_ACTIVE,
  C.SESSION_ENDED,
  C.SESSION_ADD,
  C.SESSION_UNPARKED,
  C.SESSION_UNPARKED_ELSEWHERE,
  C.SESSIONS_MERGE,
  C.UNHOLD_MERGED,
  C.HOLD_MERGED,
  C.HOLD_TOGGLE_MERGED,
  C.SESSION_TRANSFER_WARM_SET,
  C.SESSION_PARK_TERMINATED,
]

const GlobalEventMiddleware = (store) => (next) => (action) => {
  // get the state after update
  next(action)
  // only send events for necessary actions
  if (actions.includes(action.type)) {
    // get list of active calls
    const { list, parked } = store.getState().sessions
    // build session list including parked calls
    const connectedSessionList = summaryList(list, true, Object.values(parked))
    const notConnectedSessionList = summaryList(list, false)
    // dispatch the event
    eventDispatch(DISPATCH_EVENTS.CALL_LIST_UPDATE, {
      connectedSessionList,
      notConnectedSessionList,
      triggerAction: action.type,
    })
  }
}

export default GlobalEventMiddleware
